import React, { FC } from 'react';
import { WithTranslation } from 'react-i18next';
import { ReactComponent as MoreIcon } from '../../../icons/moreHoriz.svg';
import Menu from '../Menu';
import { MenuProps } from '../Menu/Menu';
import { StyledMoreMenuIcon } from './MoreMenu.styles';

export interface MoreMenuProps extends Omit<MenuProps, 'children'> {
  /** Text describing the action of the button. If not passed, a default text will be used. */
  label?: string;
  /** Deativates the button and displays a loader. */
  busy?: boolean;
}

const MoreMenu: FC<MoreMenuProps & WithTranslation> = ({ label, t, busy, disabled, ...props }) => (
  <Menu disabled={disabled} verticalOffset={10} {...props}>
    <StyledMoreMenuIcon
      Icon={MoreIcon}
      label={label || t('label')}
      disabled={disabled}
      busy={busy}
    />
  </Menu>
);

export default MoreMenu;
